import {
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React from "react";
import { DocGenerator } from "utils";
import DownloadSvg from "images/download-02.svg";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  value: {
    fontSize: "14px",
    lineHeight: "17px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#E0E0E0",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      lineHeight: "1.2rem",
    },
  },
  valuePaper: {
    padding: "1.5rem",
    cursor: "pointer",
    boxShadow: "none",
    width: "100%",
    border: "1px solid #E0E0E0",
    "&:hover": {
      background: "#E0E0E0",
      '& $downloadButton': {
        visibility: 'visible',
      }
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  menuwidth: {
    width: "200px",
    [theme.breakpoints.down("sm")]: {
      width: "150px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "130px",
    },
  },
  alginCenter: {
    textAlign: "center",
  },
  downloadButton: {
    padding: '6px',
    visibility: 'hidden',
  }
}));

const DisputeRowMuthootUser = ({
  id,
  filingDate,
  history,
  complaint_details,
  status,
}) => {
  const classes = useStyles();

  const download = (event) => {
    event.stopPropagation();
    const params = {
      primary_details: true
    }
    DocGenerator(id, "claimant", "", params);
  };

  const onRowClick = () => {
    history.push(`/disputes/${id}`);
  };

  return (
    <>
      <Paper className={classes.valuePaper} square onClick={onRowClick}>
        <Grid container spacing={2}>
          <>
            <Grid item xs sm={1}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography className={classes.value}>
                  {id ? id : "----"}
                </Typography>
              </div>
            </Grid>
            <Grid item xs sm={8}>
              <Typography className={`${classes.value} lineClamp`}>
                {complaint_details ? complaint_details : '---'}
              </Typography>
            </Grid>
            <Grid item xs sm={1}>
              <Typography className={classes.value} style={{ textAlign: 'center' }}>
                {status}
              </Typography>
            </Grid>
            <Grid item xs sm={2}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography className={classes.value} style={{ textAlign: 'center' }}>
                  <span>{format(new Date(filingDate), "dd/MM/y, h:mm a")}</span>
                </Typography>
                <Tooltip title='Download Complaint'>
                  <IconButton className={classes.downloadButton} onClick={download} >
                    <img src={DownloadSvg} width='20px' alt="" />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </>
        </Grid>
      </Paper>
    </>
  );
};

export default DisputeRowMuthootUser;
